






























import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class Error extends Vue {
  @Prop({
    default: "25",
  })
  height;
}
